<template>
  <el-card class="box-card user">
    <div slot="header" class="clearfix">
      <!-- 标题 -->
      <span class="font-sz24">用户列表</span>
      <div class="head-text">
        <el-input
          placeholder="请输入用户姓名"
          class="search-input"
          v-model="query"
        ></el-input>
        <el-button
          slot="append"
          icon="el-icon-search"
          @click="getData"
          class="mar-r80"
        ></el-button>
        <el-button type="primary" @click="exportExcel">导出</el-button>
      </div>
    </div>
    <!-- 表格 -->
    <div class="user-table">
      <el-table
        :data="userList"
        class="width100"
        height="76vh"
        v-loading="loading"
        :default-sort="{ prop: 'date', order: 'ascending' }"
      >
        <el-table-column
          align="center"
          type="selection"
          width="55"
        ></el-table-column>
        <el-table-column
          align="center"
          type="index"
          width="50"
          label="序号"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="Account"
          label="帐号"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="Name"
          label="姓名"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="Sex"
          label="性别"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="Company"
          label="公司"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="Job"
          label="职称"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="PhoneNumber"
          label="手机号"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="Email"
          label="邮箱"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="Address"
          label="地点"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="CompanyAdmin"
          label="管控公司"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="AddTime"
          width="160"
          label="创建时间"
          sortable
        ></el-table-column>
        <el-table-column class="test" align="center" label="操作" width="280">
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="small"
              plain
              @click="seeDialogFormVisible(scope.row)"
              >查看</el-button
            >
            <el-button
              type="primary"
              class="mar-left5"
              size="small"
              plain
              @click="AdminUpdatePwd(scope.row)"
              >修改密码</el-button
            >
            <el-button
              type="primary"
              class="mar-left5"
              size="small"
              plain
              @click="changeIphone(scope.row)"
              >变更手机号</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="page">
      <el-pagination
        class="mar-top20"
        align="center"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagenum"
        :page-sizes="[100, 50, 10]"
        :page-size="pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>

    <!-- 查看详情 -->
    <el-dialog
      :close-on-click-modal="false"
      title="查看用户详情"
      :visible.sync="seeDialogFormVisible1"
      class="margin0"
      top="3%"
      width="90%"
    >
      <el-row>
        <el-col :span="11">
          <el-form :model="userInfoList" label-width="80px" ref="userInfoList">
            <el-form-item label="账号" prop="user02">
              <el-input
                v-model="userInfoList.user02"
                auto-complete="off"
                :disabled="true"
              ></el-input>
            </el-form-item>
            <el-form-item label="姓名" prop="user04">
              <el-input
                v-model="userInfoList.user04"
                auto-complete="off"
                :disabled="true"
              ></el-input>
            </el-form-item>
            <el-form-item label="性别" prop="user05">
              <el-input
                v-model="userInfoList.user05"
                auto-complete="off"
                :disabled="true"
              ></el-input>
            </el-form-item>
            <el-form-item label="出生年月" prop="user06">
              <el-date-picker
                v-model="userInfoList.user06"
                type="date"
                placeholder="选择日期"
                :disabled="true"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="职称" prop="user07">
              <el-input
                v-model="userInfoList.user07"
                auto-complete="off"
                :disabled="true"
              ></el-input>
            </el-form-item>
            <el-form-item label="学历" prop="user08">
              <el-input
                v-model="userInfoList.user08"
                auto-complete="off"
                :disabled="true"
              ></el-input>
            </el-form-item>
            <el-form-item label="毕业院校" prop="user09">
              <el-input
                v-model="userInfoList.user09"
                auto-complete="off"
                :disabled="true"
              ></el-input>
            </el-form-item>
            <el-form-item label="联系地址" prop="user10">
              <el-input
                v-model="userInfoList.user10"
                auto-complete="off"
                :disabled="true"
              ></el-input>
            </el-form-item>
            <el-form-item label="手机号" prop="user11">
              <el-input
                v-model="userInfoList.user11"
                auto-complete="off"
                :disabled="true"
              ></el-input>
            </el-form-item>
            <el-form-item label="邮箱" prop="user12">
              <el-input
                v-model="userInfoList.user12"
                auto-complete="off"
                :disabled="true"
              ></el-input>
            </el-form-item>
            <el-form-item label="添加时间" prop="user15N">
              <el-input
                v-model="userInfoList.user15N"
                auto-complete="off"
                :disabled="true"
              ></el-input>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="11" :offset="1">
          <el-select
            filterable
            @change="changeCmpanyId"
            v-model="companyID"
            placeholder="显示该用户加入得公司"
          >
            <el-option
              :label="item.comp02"
              :value="item.comp01"
              v-for="(item, index) in companyList"
              :key="index"
            ></el-option>
          </el-select>
          <div class="user-loading">
            <img src="../../assets/img/dw.png" alt />
            <p>
              机构组织：
              <span>{{ project.dept }}</span>
            </p>
          </div>
          <div class="user-loading">
            <img src="../../assets/img/zw.png" alt />
            <p>
              担任职位：
              <span>{{ project.zhiwei }}</span>
            </p>
          </div>
          <div class="user-loading">
            <el-button size="small" @click="jopProject(1)"
              >管理的项目</el-button
            >
            <el-button size="small" @click="jopProject(0)" class="mar-left10"
              >参与的项目</el-button
            >
          </div>
          <div class="user-loading-table">
            <el-table
              class="margin-20 table width100"
              v-loading="loading"
              :data="projectList"
              border
              height="400px"
            >
              <el-table-column
                align="center"
                type="selection"
                width="55"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="proj01"
                label="ID"
                width="80"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="proj02"
                label="项目编号"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="proj03"
                label="项目名称"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="rolename"
                label="职位"
              ></el-table-column>
            </el-table>
            <div class="page">
              <el-pagination
                class="mar-top30"
                align="center"
                @size-change="handleSizeChange2"
                @current-change="handleCurrentChange2"
                :current-page="pageIndex"
                :page-sizes="[100, 50, 10]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total2"
              ></el-pagination>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-dialog>
  </el-card>
  <!-- </div> -->
</template>
<script>
import FileSaver from "file-saver";
import XLSX from "xlsx";
import {
  GetUserList,
  GetUserInfo,
  GetUserCompanyList,
  GetProjectList,
  QuitUser,
  AdminUpdatePwd,
  changeIph
} from "@/setAxios.js";
export default {
  name: "adminUser",
  props: ["showAdmin"],
  data() {
    return {
      isPM: "",
      loading: true,
      // 该用户参加得公司
      userList: [],
      query: "",
      total: 0,
      total2: 0,
      pagesize: 10,
      pagenum: 1,
      pageIndex: 1,
      pageSize: 10,
      seeDialogFormVisible1: false,
      userInfoList: {},
      companyList: [],
      // 这里是公司Id
      companyID: null,
      projectList: [],
      project: {},
      id: "",
    };
  },
  //   模型初始化时调用方法请求接口
  created() {
    this.getData();
    //(this.$store.state.token, "这里是token");
  },
  mounted() {},
  methods: {
    // 修改密码
    AdminUpdatePwd(row) {
      this.$prompt("请输入修改的密码", "修改密码", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(({ value }) => {
        this.$confirm("此操作将修改该用户的密码！", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          let params = {
            uid: row.id,
            pwd: value,
          };
          AdminUpdatePwd(params).then((res) => {
            if (res.Code > 0) {
              this.$message({
                type: "success",
                message: "密码修改成功",
              });
            }
          });
        });
      });
    },
    //变更手机号
    changeIphone(row){
      this.$prompt("请输入新手机号","变更手机号",{
        confirmButtonText:"确定",
        cancelButtonText:"取消",
      }).then(({value})=>{
        this.$confirm("此操作将修改该用户的手机号！", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(()=>{
          let params={
            uid:row.id,
            newPhoneNum:value
          };
          changeIph(params).then(res=>{
            if(res.Code==1){
              this.$message.success(res.Message);
              this.getData();
            }else{
              this.$message.error(res.Message);
            }
          })
        })
      })
    },
    // 强制下线功能
    QuitUser(row) {
      //(row);
      this.$confirm("是否下线?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let params = {
            uid: row.id,
          };
          QuitUser({ ...params }).then((res) => {
            if (res.Code > 0) {
              this.$message({
                type: "success",
                message: "已强制下线！",
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    changeCmpanyId(data) {
      //(data);
      this.companyID = data;
      this.jopProject();
    },
    // 导出表格所用
    exportExcel() {
      // 设置当前日期
      let time = new Date();
      let year = time.getFullYear();
      let month = time.getMonth() + 1;
      let day = time.getDate();
      let name = year + "" + month + "" + day;
      // //(name)
      /* generate workbook object from table */
      //  .table要导出的是哪一个表格
      var wb = XLSX.utils.table_to_book(document.querySelector(".user-table"));
      /* get binary string as output */
      var wbout = XLSX.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "array",
      });
      try {
        //  name+'.xlsx'表示导出的excel表格名字
        FileSaver.saveAs(
          new Blob([wbout], { type: "application/octet-stream" }),
          name + ".xlsx"
        );
      } catch (e) {
        // if (typeof console !== "undefined") //(e, wbout);
      }
      return wbout;
    },
    // 这里是查看
    seeDialogFormVisible(row) {
      this.seeDialogFormVisible1 = true;
      let params = { id: row.id };
      this.id = row.id;
      GetUserInfo({ params }).then((res) => {
        this.userInfoList = res.Data;
        //(res);
      });
      GetUserCompanyList({ params }).then((res) => {
        //(res, "所属公司");
        this.companyList = res.Data;
        this.companyID = res.Data[0].comp01;
        this.jopProject();
      });
    },
    // 这里获取再此公司参加过的项目
    jopProject(value) {
      let params2 = {
        pid: this.companyID,
        uid: this.id,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        isPM: value == undefined ? "" : value,
      };
      GetProjectList({ params: params2 }).then((res) => {
        //(res, "参加过的项目");
        this.loading = false;
        this.project = res.Data;
        this.projectList = res.Data.list;
        this.total2 = res.Data.total;
      });
    },
    // 这里获取所有数据
    getData() {
      this.loading = true;
      let params = {
        seachword: this.query,
        pagenum: this.pagenum,
        pagesize: this.pagesize,
      };
      GetUserList({ params }).then((res) => {
        this.userList = res.Data.list;
        this.loading = false;
        this.total = res.Data.total;
      });
    },
    handleSizeChange(val) {
      //   //(`每页 ${val} 条`)
      this.pagesize = val;
      this.getData();
    },
    handleSizeChange2(val) {
      //   //(`每页 ${val} 条`)
      this.pageSize = val;
      this.jopProject();
    },
    handleCurrentChange(val) {
      this.loading = true;
      this.pagenum = val;
      this.getData();
    },
    handleCurrentChange2(val) {
      this.loading = true;
      this.pageIndex = val;
      this.jopProject();
    },
    // 关闭菜单栏显示
    adminshow() {
      this.$emit("update:showAdmin", true);
    },
  },
};
</script>
<style lang="less" scoped>
.user .search-input {
  width: 300px;
}
table.el-table__header {
  line-height: 60px;
}

.el-button {
  margin: 0;
}

.user-loading {
  display: flex;
  margin: 10px 0;
  p {
    margin: 8px 0 0 10px;
    span {
      color: #007acc;
    }
  }
}

.box-card {
  overflow: hidden;
}
// 新增
.font-sz24 {
  font-size: 24px;
}
.head-text {
  float: right;
  margin-top: -4px;
}
.mar-r80 {
  margin-right: 80px;
}
.width100 {
  width: 100%;
}
.mar-left5 {
  margin-left: 5px;
}
.mar-top20 {
  margin-top: 20px;
}
.margin0 {
  margin: 0;
}
.mar-left10 {
  margin-left: 10px;
}
.mar-top30 {
  margin-top: 30px;
}
</style>
